var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-subject-builder-sidebar"},[_c('header',[_c('ed-icon',{attrs:{"icon":"xclose"},nativeOn:{"click":function($event){return _vm.closeSidebar();}}})],1),_c('main',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }